import { API_BASE_URL } from '../services/api';
import { signupPlatform, deviceOS } from './attribution';

// Anonymous, pre-signup funnel tracking. A per-tab session id stitches the
// steps together without any PII. Fire-and-forget — never blocks or breaks UI.
// Every event carries the shell (ios app / android app / web) and the device
// OS so store installs that never sign up are still visible per platform.
const SESSION_KEY = 'fueltron_onboarding_session';

function getSessionId(): string {
  const existing = sessionStorage.getItem(SESSION_KEY);
  if (existing) return existing;
  const id = (typeof crypto !== 'undefined' && (crypto as any).randomUUID)
    ? (crypto as any).randomUUID()
    : `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
  sessionStorage.setItem(SESSION_KEY, id);
  return id;
}

export function trackOnboarding(event: string, meta?: Record<string, any>): void {
  try {
    fetch(`${API_BASE_URL}/onboarding/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sessionId: getSessionId(), event, meta: { ...(meta || {}), platform: signupPlatform(), os: deviceOS(), wd: typeof navigator !== 'undefined' && (navigator as any).webdriver === true } }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* tracking must never break onboarding */
  }
}
